
import { defineComponent, onBeforeMount, reactive, toRaw } from 'vue'

// components
import Modal from '@/common/components/UI/Modal/index.vue'
import TheInput from '@/common/components/UI/TheInput/index.vue'
import TheSelect from '@/common/components/UI/TheSelect/index.vue'

// validations
import { CompaniesGenerateContractValidation } from '@/modules/CompaniesModule/validations/CompaniesActions.validation'
import useVuelidate from '@vuelidate/core'

// classes
import { DataState } from '@/core/classes/DataState.class'

// realisations
import { companies } from '@/core/realisations/companies.realisation'

export default defineComponent({
    components: {
        modal: Modal,
        'the-input': TheInput,
        'the-select': TheSelect,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['cancel', 'generate'],
    setup(_, { emit }) {
        const state = reactive({
            fullname_initials: null as string | null,
            base: null as number | null,
        })

        const state_form$ = useVuelidate(CompaniesGenerateContractValidation, state)

        const emitCancel = () => {
            emit('cancel')
        }

        const emitGenerate = () => {
            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            emit('generate', toRaw(state))
        }

        const bases_state = reactive(new DataState<{ id: number; name: string }>({}))

        const loadBases = async () => {
            try {
                bases_state.is_loading = true

                const data = await companies.getCompanyBases()

                const bases = Object.values(data.data).map((base: string, index: number) => {
                    return { id: index + 1, name: base }
                })

                bases_state.list = bases

                bases_state.is_failed = false
                bases_state.failure.error_state.is_cancel = false
            } catch (error) {
                bases_state.failure.catchError(error)
                if (!bases_state.failure.error_state.is_cancel) {
                    bases_state.is_failed = true
                }
            } finally {
                if (!bases_state.failure.error_state.is_cancel) {
                    bases_state.is_loading = false
                }
            }
        }

        onBeforeMount(loadBases)

        return { state, state_form$, emitCancel, emitGenerate, bases_state, loadBases }
    },
})
